export default __webpack_public_path__ + "static/Guides_1-20b13b2d79de62dc8a1438b852f0d4ce.webp";